/**
 * Vehicle Picker - Header Link
 * Opens the vehicle selector popup when "Pick your vehicle" is clicked
 */

document.addEventListener('DOMContentLoaded', function() {
  const vehiclePicker = document.querySelector('.js-vehicle-picker');

  if (vehiclePicker) {
    vehiclePicker.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Open the vehicle selector popup
      const popup = document.getElementById('vehicle-selector-popup');
      if (popup) {
        popup.style.display = 'flex';

        // Mark that popup was shown (so auto-popup doesn't trigger again)
        localStorage.setItem('vehiclePopupShown', 'true');
      }
    });
  }
});
